import React from 'react';
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const THRESHOLD_ROWS = [
  {
    component: 'Recovery',
    lowRisk: '>= 67',
    mediumRisk: '34 to 66.99',
    highRisk: '< 34',
  },
  {
    component: 'Sleep performance',
    lowRisk: '>= 67',
    mediumRisk: '34 to 66.99',
    highRisk: '< 34',
  },
  {
    component: 'Strain (lower is better)',
    lowRisk: '<= 15',
    mediumRisk: '15.01 to 18',
    highRisk: '> 18',
  },
  {
    component: 'HRV',
    lowRisk: '>= 45',
    mediumRisk: '35 to 44.99',
    highRisk: '< 35',
  },
];

export const RiskScoringMethodDetails: React.FC = () => {
  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant='subtitle2'>How Risk Is Calculated</Typography>
        <Typography variant='body2' color='text.secondary'>
          We score four components (Recovery, Sleep, Strain, and HRV). Each component is converted to a banded risk
          score of 0 (good), 50 (warning), or 100 (high risk) using the thresholds below.
        </Typography>
      </Box>

      <Box>
        <Typography variant='subtitle2' sx={{ mb: 1 }}>
          Component Thresholds
        </Typography>
        <TableContainer>
          <Table size='small' aria-label='risk score thresholds'>
            <TableHead>
              <TableRow>
                <TableCell>Component</TableCell>
                <TableCell>Low Risk (0)</TableCell>
                <TableCell>Medium Risk (50)</TableCell>
                <TableCell>High Risk (100)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {THRESHOLD_ROWS.map((row) => (
                <TableRow key={row.component}>
                  <TableCell>{row.component}</TableCell>
                  <TableCell>{row.lowRisk}</TableCell>
                  <TableCell>{row.mediumRisk}</TableCell>
                  <TableCell>{row.highRisk}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box>
        <Typography variant='subtitle2'>Overall Score And Risk Level</Typography>
        <Typography variant='body2' color='text.secondary'>
          Risk score is the average of the four banded component scores, rounded for display. Risk levels are assigned
          as High (&gt;= 67), Medium (34 to 66.99), or Low (&lt; 34).
        </Typography>
      </Box>

      <Box>
        <Typography variant='subtitle2'>Additional Logic</Typography>
        <Typography variant='body2' color='text.secondary'>
          Days in Red is the count of recovery entries where recovery score is &lt;= 33 in the selected date range. In
          anonymised mode, the same model is applied at department level using averaged member metrics, and only
          departments with at least 2 members are shown. Missing metric values are currently treated as 0 before
          scoring.
        </Typography>
      </Box>

      <Box>
        <Typography variant='subtitle2'>Cadence</Typography>
        <Typography variant='body2' color='text.secondary'>
          Jeopardy Insights uses the currently selected date range and averages all available data inside that window.
          It is not fixed to a weekly or monthly batch, so there is no hard-coded week start such as Monday.
        </Typography>
      </Box>
    </Stack>
  );
};
